@if (isLoading) {
  <app-circle-loader class="w-6 h-6" [appearance]="'dark'"></app-circle-loader>
} @else {
  <ng-content></ng-content>

  @if (value && pinnedLabel) {
    <ng-container *ngTemplateOutlet="valueWithPinnedLabel"></ng-container>
  }

  @if (value && !pinnedLabel) {
    <ng-container *ngTemplateOutlet="valueWithoutPinnedLabel"></ng-container>
  } @else {
    <span class="text-navy-70 whitespace-nowrap p-1" [innerHTML]="placeholder"></span>
  }
}

@if (!disabledFilterState) {
  <svg-icon
    class="chevron absolute right-0 transform rotate-90 mr-2.5"
    preserveAspectRatio="none"
    [src]="'chevrone'"
    [stretch]="true"
  ></svg-icon>
}

<ng-template #valueWithPinnedLabel>
  <div #container class="field-container overflow-hidden absolute whitespace-nowrap">
    @if (showTooltipAlwaysOnHover) {
      <span
        class="field"
        [style.max-width.px]="container.offsetWidth - label.offsetWidth"
        [ngbTooltip]="tooltip"
        [placement]="tooltipPlacement"
      >
        {{ value }}
      </span>
    } @else {
      <span
        class="field"
        [style.max-width.px]="container.offsetWidth - label.offsetWidth"
        [openTooltipWhenOverflowedAndHovered]="true"
        [openOnWidthOverflow]="true"
        [ngbTooltip]="tooltip"
        [placement]="tooltipPlacement"
      >
        {{ value }}
      </span>
    }

    <span #label class="pinned-label">&nbsp;{{ pinnedLabel }}</span>
  </div>
</ng-template>

<ng-template #valueWithoutPinnedLabel>
  <span class="field-container relative p-1">
    @if (showTooltipAlwaysOnHover) {
      <span class="field" [ngbTooltip]="tooltip" [placement]="tooltipPlacement">
        {{ value }}
      </span>
    } @else {
      <span
        class="field"
        [ngbTooltip]="tooltip"
        [openTooltipWhenOverflowedAndHovered]="true"
        [openOnWidthOverflow]="true"
        [placement]="tooltipPlacement"
      >
        {{ value }}
      </span>
    }
    @if (iconNextToValue) {
      <svg-icon class="ml-2" [src]="iconNextToValue"></svg-icon>
    }    
  </span>
</ng-template>
